export default __webpack_public_path__ + "static/footer_logo_mogstation-8ddd7e55-b15cda6bebbcaac7eaeae598a901239f.png";